"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFederatedAuthProvider = exports.AuthProvidersByProviderName = exports.federatedAuthProviders = exports.AUTH_PROVIDER_ATTRIBUTE_NAME = exports.SAML_PROVIDER_NAME = exports.OKTA_PROVIDER_NAME = exports.APPLE_PROVIDER_NAME = exports.GOOGLE_PROVIDER_NAME = exports.COGNITO_PROVIDER_NAME = exports.ADMIN_PRE_SIGNUP_TRIGGER = exports.THIRD_PARTY_PRE_SIGNUP_TRIGGER = exports.PRE_AUTH_TRIGGER = void 0;
exports.PRE_AUTH_TRIGGER = 'PreAuthentication_Authentication';
exports.THIRD_PARTY_PRE_SIGNUP_TRIGGER = 'PreSignUp_ExternalProvider';
exports.ADMIN_PRE_SIGNUP_TRIGGER = 'PreSignUp_AdminCreateUser';
exports.COGNITO_PROVIDER_NAME = 'Cognito';
exports.GOOGLE_PROVIDER_NAME = 'Google';
exports.APPLE_PROVIDER_NAME = 'SignInWithApple';
exports.OKTA_PROVIDER_NAME = 'Okta';
exports.SAML_PROVIDER_NAME = 'SAML';
exports.AUTH_PROVIDER_ATTRIBUTE_NAME = 'Cognito_Subject';
exports.federatedAuthProviders = [
    'Google',
    'Apple',
    'Okta',
    'SAML',
];
exports.AuthProvidersByProviderName = {
    [exports.COGNITO_PROVIDER_NAME]: 'Cognito',
    [exports.GOOGLE_PROVIDER_NAME]: 'Google',
    [exports.APPLE_PROVIDER_NAME]: 'Apple',
    [exports.OKTA_PROVIDER_NAME]: 'Okta',
    [exports.SAML_PROVIDER_NAME]: 'SAML',
};
const isFederatedAuthProvider = (authProvider) => exports.federatedAuthProviders.includes(authProvider);
exports.isFederatedAuthProvider = isFederatedAuthProvider;
//# sourceMappingURL=cognito.js.map